import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../styles/profile-menu.css';

export type ProfileMenuItem = 
  | 'basic-info'
  | 'preferences'
  | 'experience'
  | 'volunteer-experience'
  | 'certifications'
  | 'education'
  | 'projects'
  | 'links';

export const MENU_ITEMS: { key: ProfileMenuItem; label: string }[] = [
  { key: 'basic-info', label: 'Basic Info' },
  { key: 'preferences', label: 'Preferences' },
  { key: 'experience', label: 'Experience' },
  { key: 'volunteer-experience', label: 'Volunteer Experience' },
  { key: 'certifications', label: 'Certifications' },
  { key: 'education', label: 'Education' },
  { key: 'projects', label: 'Projects' },
  { key: 'links', label: 'Links' },
];

export const ProfileMenu: React.FC = () => {
  const { tab } = useParams<{ tab: ProfileMenuItem }>();
  const activeItem = tab || 'basic-info';

  return (
    <nav className="profile-menu">
      {MENU_ITEMS.map((item) => (
        <Link
          key={item.key}
          to={`/profile/builder/${item.key}`}
          className={`profile-menu__item ${activeItem === item.key ? 'profile-menu__item--active' : ''}`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

